import type { SnackbarCloseReason } from "@mui/material/Snackbar";

/** Auto-dismiss delay for call-plan Snackbars (ms). */
export const CALL_PLAN_SNACKBAR_AUTO_HIDE_MS = 6000;

export const callPlanSnackbarOnClose =
  (dismiss: () => void) => (_event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === "clickaway") {
      return;
    }
    dismiss();
  };
